<div class="widget-card">
  <div class="widget-header">
    <div class="widget-title">
      <h3>Automated Response Usage</h3>
      <kendo-svg-icon
        [icon]="infoCircleIcon"
        size="small"
        class="info-icon"
        kendoTooltip
        title="Shows usage counts for each of the 6 automated response use cases (ARU) available."
      ></kendo-svg-icon>
    </div>
    <kendo-dropdownbutton
      [svgIcon]="moreVerticalIcon"
      fillMode="flat"
      size="small"
      [data]="[{ text: 'View Data' }]"
      (itemClick)="onContextMenuSelect({ text: 'View Alert Data' })"
    ></kendo-dropdownbutton>
  </div>

  <div class="summary-stats">
    <div class="total-usage">
      <span class="total-label">Total Automated Responses:</span>
      <span class="total-count">{{ totalUsages().toLocaleString() }}</span>
    </div>
  </div>

  <div class="usage-metrics">
    <div class="usage-columns">
      @for (item of formattedData(); track item.use_case; let i = $index) {
        <div class="usage-row">
          <div class="usage-info">
            <span class="use-case-name">{{ item.description }}</span>
            <span class="use-case-description">{{ item.use_case }}</span>
          </div>
          <div class="usage-count">
            <span class="count-value">{{ item.formattedCount }}</span>
            <span class="count-label">uses</span>
          </div>
        </div>
      }
    </div>
  </div>
</div>

<!-- Reusable Alert Data Dialog -->
@if (alertDialogConfig()) {
  <app-alert-data-dialog
    [config]="alertDialogConfig()!"
    [visible]="showAlertDialog()"
    (close)="onAlertDialogClose()"
    (exportCsv)="triggerExport()"
  />
}
